// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1DmrS","col":"styles_col__189Ol"};